import React from "react";
import InputField from "../input/inputField";
import { useGetAudienceOptions } from "../../hooks/audienceHooks/audience.hooks";
import Dropdown from "../Dropdown/dropdown";
import { DropdownOptions } from "../dropdownOptions";
import { getValue, isEmpty } from "../../utils/object.utils";
import { useGetNotificationCategoryeOptions } from "../../hooks/notifications/notifications.hooks";

interface Props {
  title: string;
  setTitle: (titleName: string) => unknown;
  text: string;
  setText: (textName: string) => unknown;
  audienceId: number | null;
  setAudienceId: (audience: number | null) => unknown;
  notificationCategoryKey: string | null;
  setNotificationCategoryKey: (notificationCategoryKey: string) => unknown;
  setSelectedAudienceValue: (audienceValue: string) => unknown;
  setSelectNotificationCategory: (audienceCategory: string) => unknown;
}

export const NotificationForm = ({
  title,
  setTitle,
  text,
  setText,
  audienceId,
  setAudienceId,
  notificationCategoryKey,
  setNotificationCategoryKey,
  setSelectedAudienceValue,
  setSelectNotificationCategory,
}: Props) => {
  const { data: AUDIENCE_OPTIONS } = useGetAudienceOptions();
  // const { data: AUDIENCE_CATEGORY_OPTIONS } = useGetAudiencCategoryeOptions();
  const { data: NOTIFICATION_CATEGORY_OPTIONS } =
    useGetNotificationCategoryeOptions();

  const onAudienceSelect = (selectedAudience: object) => {
    if (!selectedAudience || isEmpty(selectedAudience)) return;
    const audienceId = getValue(selectedAudience, "value");
    const audienceValue = getValue(selectedAudience, "text");

    setAudienceId(audienceId);
    setSelectedAudienceValue(audienceValue);
  };

  const onNotificationCategorySelect = (notificationCategoryKey: string) => {
    setNotificationCategoryKey(notificationCategoryKey);
    setSelectNotificationCategory(notificationCategoryKey);
  };

  return (
    <div className="flex flex-col">
      <InputField
        value={title}
        setValue={setTitle}
        label="Title name"
        placeHolder="Enter title name"
      />
      <InputField
        value={text}
        setValue={setText}
        label="Body"
        placeHolder="Enter body"
      />

      <Dropdown
        label="Select category"
        options={NOTIFICATION_CATEGORY_OPTIONS || []}
        selectedOption={
          (NOTIFICATION_CATEGORY_OPTIONS || []).find(
            ({ value }: { value: any }) => value === notificationCategoryKey
          ) as DropdownOptions
        }
        setSelectedOption={(selectedOption: DropdownOptions) => {
          onNotificationCategorySelect(selectedOption.value as string);
        }}
      />

      <Dropdown
        label="Select audience"
        options={AUDIENCE_OPTIONS || []}
        selectedOption={
          (AUDIENCE_OPTIONS || []).find(
            ({ value }: { value: any }) => value === audienceId
          ) as DropdownOptions
        }
        setSelectedOption={(selectedOption: DropdownOptions) => {
          onAudienceSelect(selectedOption as any);
        }}
      />
    </div>
  );
};
